// extracted by mini-css-extract-plugin
export var center = "heading-module--center--783cb";
export var h1 = "heading-module--h1--29025";
export var h2 = "heading-module--h2--98c8a";
export var h3 = "heading-module--h3--76983";
export var h4 = "heading-module--h4--368cc";
export var h5 = "heading-module--h5--c2404";
export var h6 = "heading-module--h6--81f19";
export var spin = "heading-module--spin--f55eb";
export var standalone = "heading-module--standalone--0578a";